/**
 * Label schema terms
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const label = {
	schema: {
		label: "schema:label#label"
	},
	flow: {
		label: "schema:label.flow#label",
		description: "schema:label.flow#description"
	},
	flowValues: {
		row_icon_text: {
			label: "schema:label.flow#values.row_icon_text#label"
		},
		row_text_icon: {
			label: "schema:label.flow#values.row_text_icon#label"
		},
		column_icon_text: {
			label: "schema:label.flow#values.column_icon_text#label"
		},
		column_text_icon: {
			label: "schema:label.flow#values.column_text_icon#label"
		}
	},
	tooltip: {
		label: "schema:label.tooltip#label",
		description: "schema:label.tooltip#description"
	}
};
